import { createAsyncThunk } from "@reduxjs/toolkit";
import { addCategory, deleteCategory, fetchCategoryList, pinnedCategory, reorderCategory, updateCategory } from "src/services/category.service";
import { getAuthToken } from "../config";
import { toast } from "sonner";


export const doFetchCategoryList = createAsyncThunk(
  "category/fetchCategoryList",
  // async (payload: { search?: string; page: number; limit: number }) => {
    async (payload: { search?: string; }) => {
  
    try {
      const response: any = await fetchCategoryList({
        search: payload.search,
        // page: payload.page,
        // limit: payload.limit,
      });
      return response;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Failed to fetch category list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

// add category
export const doAddCategory= createAsyncThunk(
  "category/addCategory",
  async (body: any, { getState, rejectWithValue }) => {
    const accessToken = getAuthToken();
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }
    try {
      const response: any = await addCategory(body);
      return response;
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Failed to add category");
      return rejectWithValue(
        error.response?.data?.message || "Failed to add category"
      );
    }
  }
);

// delete category
export const doDelCategory = createAsyncThunk(
  "category/delCategory",
  async (id: string) => {
    try {
      const response: any = await deleteCategory(id);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete category";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

// pinned-unpinned category
export const doPinCategory = createAsyncThunk(
  "category/togglePinCategory",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await pinnedCategory(id);
      toast.success(response.message);
      return { id, isPinned: response.data?.isPinned };
    } catch (error: any) {
      const message =
        error.response?.data?.message || "Failed to toggle pin status";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const doUpdateCategory = createAsyncThunk(
  "category/updateCategory",
  async (
    { id, body }: { id: string; body: { title: string; image: string,description: string, icon: string } },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await updateCategory(id, body);
      toast.success("Category updated successfully!");
      return { id, data: response.data };
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Failed to update category";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// reorder category
export const doReorderCategory = createAsyncThunk(
  "category/reorderCategory",
  async (
    payload: { categoryOrderDto: { pid: string; position: number }[] },
    { rejectWithValue }
  ) => {
    try {
      // console.log(payload)
      const response: any = await reorderCategory(payload);
      toast.success(response.message);
      return payload.categoryOrderDto; 
    } catch (error: any) {
      const message =
        error.response?.data?.message || "Failed to reorder categories";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);